import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Flex, Stack } from '@chakra-ui/react';
import { ReactComponent as ExchangeMagix } from 'assets/icons/exchange_magix.svg';
import { usePublic } from 'hooks';

/** Same canvas token as authenticated dashboard (`Magix`). */
const Unauthenticated: React.FC = () => {
  usePublic();

  return (
    <Box bg="secondary" minH="100dvh" color="body">
      <Flex
        minH="100dvh"
        align="center"
        justify="center"
        px={{ base: 4, md: 6 }}
        py={{ base: 8, md: 10 }}
        w="100%"
      >
        <Stack align="center" w="100%" maxW="440px" gap={0}>
          <Box
            w="100%"
            maxW="180px"
            mb={{ base: 8, md: 10 }}
            alignSelf="center"
            css={{
              '& svg': {
                display: 'block',
                width: '100%',
                height: 'auto',
              },
            }}
          >
            <ExchangeMagix
              cursor="pointer"
              onClick={() => window.location.replace('/')}
            />
          </Box>
          <Box w="100%">
            <Outlet />
          </Box>
        </Stack>
      </Flex>
    </Box>
  );
};

export default Unauthenticated;
